import React from 'react';

const renderBubbles = () => {
    const bubbles = [];
    const numberOfBubbles = 200;

    for (let i = 0; i < numberOfBubbles; i++) {
        const size = Math.random() * (50 - 1); // Size 5px - 50px
        const animationDuration = Math.random() * (50 - 10) + 5; // Duration 2s - 240s
        const left = Math.random() * 100; // Starting position (0% to 100% of the container width)

        bubbles.push(
            <div
                key={i}
                style={{
                    width: `${size}px`,
                    height: `${size}px`,
                    borderRadius: '50%',
                    background: 'rgba(0, 0, 0, 0.2)',
                    position: 'absolute',
                    bottom: '0%',
                    left: `${left}%`,
                    animation: `bubbles ${animationDuration}s linear infinite`,
                }}                              
            />
        );
    }

    // console.log(bubbles);

    return <>{bubbles}</>;
};

export default renderBubbles;